import { render, staticRenderFns } from "./spread.vue?vue&type=template&id=e2493f5a"
import script from "./spread.vue?vue&type=script&lang=js"
export * from "./spread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports